import { MenuItem } from "../../common/AppSidebar/types";

export const compareByName = (a: MenuItem, b: MenuItem) => {
  return (a.name || "").localeCompare(b.name || "", undefined, {
    numeric: true,
    sensitivity: "base",
  });
};
